// components/AdminRoute.jsx
// Route guard: requires a valid token AND role === "admin".
// This is the client-side half of the gate; the backend independently enforces
// require_admin on every /wiki endpoint, so the content bytes are never served
// to a non-admin even if this guard is bypassed.
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { loginUrlFor } from "../utils/authRedirect";
import { getRole, getUsableToken } from "../utils/authToken";

export default function AdminRoute({ children }) {
  const location = useLocation();
  // Expired counts as absent, same as PrivateRoute. getRole also replaces a local atob() decoder
  // that could throw on a valid token: JWT payloads are base64URL, which plain atob() rejects.
  if (!getUsableToken()) {
    return <Navigate to={loginUrlFor(location)} replace />;
  }
  if (getRole() !== "admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}
